module.exports = __webpack_public_path__ + "img/multiple-endorsements.ba70f969.svg";